import { styled } from '@mui/material';

export const SvgStyled = styled('svg', {
  shouldForwardProp: (prop) => prop !== 'small' && prop !== 'big',
})(({ small, big }) => {
  const getFlagSize = () => {
    if (small)
      return {
        width: '17px',
        height: '12px',
      };

    if (big)
      return {
        width: '35px',
        height: '25px',
      };

    return {
      width: '22px',
      height: '16px',
    };
  };

  return {
    ...getFlagSize(),
    display: 'inline-block',
    marginRight: small ? '4px' : '8px',
    '&:nth-child(2)': {
      marginRight: 0,
    },
  };
});
